import { useParams } from 'react-router-dom';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { Loader } from '../../../../../../components';
import { format, parseISO } from 'date-fns';
import useManagedInstallersGeneral
  from '../../../../../../queries/managedInstallersDetails/useGetMangedInstallersGeneral';

const fieldsToRender = [
  { key: 'ruleId', label: 'Rule ID' },
  { key: 'binaryName', label: 'Binary Name' },
  { key: 'publisherName', label: 'Publisher Name' },
  { key: 'productName', label: 'Product Name' },
  { key: 'versionRange', label: 'Version Range' },
  { key: 'enforcementMode', label: 'Enforcement Mode' },
  { key: 'action', label: 'Action' },
  { key: 'name', label: 'Name' },
  { key: 'firstSeen', label: 'First Seen' },
  { key: 'lastSeen', label: 'Last Seen' },
];

const Container = ({ children }) => (
  <Box
    sx={theme => ({
      backgroundColor: '#484848',
      boxShadow: '0px 1px 2px 0px #64748B1A',
      borderRadius: theme.spacing(1),
      padding: '32px 24px',
      width: '100%',
    })}>
    {children}
  </Box>
);

const ManagedInstallersDeviceGeneralSection = () => {
  const { managedInstallerId } = useParams();
  const { isLoading, data: managedInstallerGeneral } = useManagedInstallersGeneral({ managedInstallerId });

  if (isLoading) {
    return (
      <Box mt={'80px'}>
        <Loader />
      </Box>
    );
  }

  return (
    <Container>
      <Stack spacing={2}>
        <Table>
          <TableBody>
            {fieldsToRender.map(({ key, label }) => (
              <TableRow key={key}>
                <TableCell>{label}:</TableCell>
                <TableCell>{
                  key === 'versionRange' ? (
                    <span>{`${managedInstallerGeneral['lowVersion']} - ${managedInstallerGeneral['highVersion']}`}</span>
                  ) : key === 'firstSeen' ?
                    managedInstallerGeneral['createdAt'] ? format(parseISO(managedInstallerGeneral['createdAt']), 'yyyy-MM-dd') : 'no data'
                    : key === 'lastSeen' ?
                      managedInstallerGeneral['lastSeen'] ? format(parseISO(managedInstallerGeneral['lastSeen']), 'yyyy-MM-dd') : 'no data'
                      : (
                        managedInstallerGeneral[key] || 'no data'
                      )
                } </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Stack>
    </Container>
  );
};

export default ManagedInstallersDeviceGeneralSection;
